module.exports = __webpack_public_path__ + "static/media/KAZ.4b144325.png";